import { makeStyles } from '@material-ui/core'
import Confused_User from 'src/assets/My_Policies_Images/Confused.svg'
import Idea from 'src/assets/My_Policies_Images/Idea.svg'
import { Carousel } from 'react-responsive-carousel'
import { SmartBuyersList } from 'src/utils/constants/MyPoliciesData'

const SmartBanner = () => {
  const classes = useStyles()

  const getBuyersText = () => {
    return (
      <>
        <Carousel
          infiniteLoop={true}
          showArrows={false}
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
          autoPlay={true}
          stopOnHover={false}
          className={classes.buyerTextCarousel}
        >
          {SmartBuyersList?.map((listItem, index) => (
            <span key={index} className={classes.buyerText}>
              {listItem}
            </span>
          ))}
        </Carousel>
      </>
    )
  }

  return (
    <div className={classes.mainContainer}>
      <div className={`flex ${classes.smartContainer}`}>
        <img src={Idea} alt='Rejected' className={classes.image} />
        <div className={classes.textContainer}>
          <span className={classes.bannerText}>See Smart</span>
          <span className={classes.smartText}>{getBuyersText()} Buyers</span>
        </div>
      </div>
      <div className={`flex ${classes.rejectedContainer}`}>
        <img src={Confused_User} alt='Rejected' className={classes.image} />
        <div className={classes.textContainer}>
          <span className={classes.bannerText}>Why 90% Claims are</span>
          <span className={classes.rejectedText}>Rejected</span>
        </div>
      </div>
    </div>
  )
}

export default SmartBanner

const useStyles = makeStyles({
  mainContainer: {
    border: '0px solid #D4D4D4',
    borderRadius: '10px',
    boxShadow: '0px 1px 8px 0px #0000001A',
    display: 'flex',
    '@media only screen and (max-width: 425px)': {
      flexDirection: 'column',
    },
  },
  smartContainer: {
    borderRadius: '10px 0 0 10px',
    padding: '10px 20px 10px 10px',
    borderRight: '0px solid #D4D4D4',
    paddingBottom: 0,
    gap: '5px',
    '@media only screen and (max-width: 425px)': {
      borderBottom: '1px solid #D4D4D4',
      borderRight: 'unset',
      borderRadius: '10px 10px 0 0',
      boxShadow: '0px 1px 8px 0px #0000001A',
    },
  },
  rejectedContainer: {
    borderRadius: '0 10px 10px 0',
    padding: '10px 10px 10px 20px',
    paddingBottom: 0,
    gap: '5px',
    boxShadow: '0px 1px 8px 0px #0000001A',
  },
  image: {},
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'center',
  },
  bannerText: {
    fontSize: '12px',
  },
  rejectedText: {
    fontSize: '15px',
    color: '#F95959',
    fontWeight: 'bold',
  },
  smartText: {
    fontSize: '15px',
    color: '#1C89E6',
    fontWeight: 'bold',
    display: 'flex',
  },
  buyerTextCarousel: {
    width: '100%',
    maxWidth: '60px',
  },
  buyerText: {
    textAlign: 'left',
  },
})
